<template>
  <NewsletterQuickSubscription :config="config" />
</template>

<script>
import NewsletterQuickSubscription from "../../components/NewsletterQuickSubscription/NewsletterQuickSubscription.vue";

export default {
  name: "app",
  components: {
    NewsletterQuickSubscription
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
